module.exports = __webpack_public_path__ + "img/popup_newexam_classtitle.7540e232.svg";